<template>
  <div class="">
    <ZnBreadcrumb />
    <div class="main-content" data-title="组内专用_试剂采购库存管理系统">
      <div class="search-type">
        <ul class="clearfix">
          <li>
            <div class="search-wrapper">
              <el-input
                  v-model="searchData.reagentName"
                  placeholder="请输入关键字"
                  prefix-icon="el-icon-search"
                  type="text"
                  @keyup.enter.native="borrowList"
              />
            </div>
            <!-- <img src="../../assets/images/searchIcon.png" alt="" />
            <input
              type="text"
              style="margin-right:15px"
              placeholder="请输入关键字"
              v-model="searchData.reagentName"
              @keyup.enter="borrowList"
            /> -->
            <div class="search-wrapper">
              <span>状态选择</span>
              <el-select
                  v-model="searchData.operation"
                  placeholder="请选择"
                  @change="getRecord()"
              >
                <el-option
                    v-for="item in operations"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>

            <div class="search-wrapper">
              <span>转用类型</span>
              <el-select
                  v-model="searchData.borrowRole"
                  placeholder="请选择"
                  @change="getRecord()"
              >
                <el-option
                    v-for="item in borrowRoleData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>

            <div class="search-wrapper">
              <el-button type="primary" size="small" class="cursorPointer" @click="borrowList">
                快速查询
              </el-button>
            </div>
            <!--            <button class="cursorPointer" @click="putOut">导出</button>-->
          </li>
        </ul>
      </div>
      <div class="table-container">
        <el-table
            :data="borrowData"
            :header-cell-style="{
            background: '#F8FAFC',
            color: '#000000',
            fontWeight: 700,
            height: '54px',
          }"
            border
            style="width: 100%"
            class="supTable"
        >
          <template slot="empty">
            <img src="../../assets/images/emptyCabinet.png" class="empty" />
            <p>暂无转用信息</p>
          </template>
          <el-table-column prop="reagentCode" label="试剂编号" width="110px">
          </el-table-column>
          <el-table-column prop="reagentName" label="试剂名称">
          </el-table-column>

          <el-table-column prop="borrowUserName" label="转用申请人">
          </el-table-column>
          <el-table-column prop="borrowTaskName" label="所属课题组">
          </el-table-column>
          <el-table-column prop="casNo" label="CAS号"> </el-table-column>
          <el-table-column label="转用时间" prop="subscribeTime" width="160px"> </el-table-column>
          <el-table-column label="归还时间" prop="giveBackTime" width="160px"> </el-table-column>
<!--          <el-table-column label="归还时间">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.backTime">{{-->
<!--                  scope.row.backTime | timeYMD-->
<!--                }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="cabName" label="柜机名称"> </el-table-column>
          <el-table-column prop="cabAddress" label="柜机位置">
          </el-table-column>
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.lendOperation == 0">转用申请中</span>
              <span v-if="scope.row.lendOperation == 1">转用完成</span>
              <span v-if="scope.row.lendOperation == 2">转用失败</span>
              <span v-if="scope.row.lendOperation == 3">已拒绝</span>
              <span v-if="scope.row.lendOperation == 4">已取消</span>
              <span v-if="scope.row.lendOperation == 5">已同意</span>
              <span v-if="scope.row.lendOperation == 6">已归还</span>
              <!-- <span v-if="scope.row.operation == 4">已归还</span> -->
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.reason ? scope.row.reason : "/" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="middle"
                v-if="scope.row.operation == 1"
                @click="putOutSuccess(scope.row)"
                >取出</el-button
              >

              <el-button
                type="text"
                size="middle"
                v-if="scope.row.operation == 2"
                @click="putBackSuccess(scope.row)"
                >归还</el-button
              > -->

              <img
                  @click="cancelBorrowApply(scope.row)"
                  v-if="
                  scope.row.borrowStatus == 0 && currentUserId == scope.row.borrowUserId &&
                  (scope.row.borrowRole == 1 || scope.row.borrowRole == 0)
                "
                  src="../../assets/private/取消订单.png"
                  title="取消申请"
                  style="height: 25px; width: 25px; float: left"
              />

              <img
                  @click="agreeBorrowApply(scope.row)"
                  v-if="
                  scope.row.borrowStatus == 0 && currentUserId == scope.row.takingUserId &&
                  (scope.row.borrowRole == 2  || scope.row.borrowRole == 0)
                "
                  src="../../assets/private/同意转借.png"
                  title="同意转借"
                  style="height: 25px; width: 25px; float: left"
              />

              <img
                  @click="disBorrowApply(scope.row)"
                  v-if="
                  scope.row.borrowStatus == 0 && currentUserId == scope.row.takingUserId &&
                  (scope.row.borrowRole == 2  || scope.row.borrowRole == 0)
                "
                  src="../../assets/private/拒绝转借.png"
                  title="拒绝转借"
                  style="height: 25px; width: 25px; float: left"
              />

              <img
                  @click="confirmGet(scope.row)"
                  v-if="
                  scope.row.borrowStatus == 1 && scope.row.isOver == 0 && currentUserId == scope.row.borrowUserId &&
                  (scope.row.borrowRole == 1  || scope.row.borrowRole == 0)
                "
                  src="../../assets/private/确认收到.png"
                  title="已收到"
                  style="height: 25px; width: 25px; float: left"
              />

              <img
                  @click="disGet(scope.row)"
                  v-if="
                  scope.row.borrowStatus == 1 && scope.row.isOver == 0 && currentUserId == scope.row.borrowUserId &&
                  (scope.row.borrowRole == 1  || scope.row.borrowRole == 0)
                "
                  src="../../assets/private/取消订单.png"
                  title="未收到"
                  style="height: 25px; width: 25px; float: left"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
          :dataTotal="total"
          :totalpage="totalpage"
          :pagesize="searchData.pageSize"
          @changePage="changePage"
      ></Pagination>

    </div>
  </div>
</template>
<script>
import moment from "moment";
import {EventBus} from "@/config/event-bus";
export default {
  data() {
    return {
      searchData: {
        reagentName: "",
        operation: "",
        pageNum: 1,
        pageSize: 10,
        borrowRole: 0,
      },
      currentUserId: null,
      borrowData: [],
      total: 0,
      totalpage: 0,
      borrowRoleData: [
        {
          value: 0,
          label: "全部",
        },
          {
            value: 1,
            label: "转入",
          },
          {
            value: 2,
            label: "转出",
          }
      ],
      operations: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "转用申请中",
        },
        {
          value: 1,
          label: "转用完成",
        },
        {
          value: 2,
          label: "转用失败",
        },
        {
          value: 3,
          label: "已拒绝",
        },
        {
          value: 4,
          label: "已取消",
        },
        {
          value: 5,
          label: "已同意",
        },
        {
          value: 6,
          label: "已归还",
        },
      ],
      userId: "",
    };
  },
  created() {
    const { visitType } = this.$route.query;
    if (visitType == "4") {
      this.searchData.operation = this.operations[4].value;
    } else if (visitType == "5") {
      this.searchData.operation = this.operations[5].value;
    }
    this.borrowList();
    this.getUserId();

    const currentUser = localStorage.getItem('userInfo')
    this.currentTaskId = JSON.parse(currentUser).taskId
    this.currentUserId = JSON.parse(currentUser).id
  },
  filters: {
    timeYMD(str) {
      return moment(str).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  methods: {
    getUserId() {
      const user = JSON.parse(localStorage.getItem("userInfo"));
      this.userId = user.id;
    },

    getRecord() {
      // 筛选
      this.searchData.pageNum = 1;
      this.borrowList();
    },
    //借用列表
    borrowList() {
      let params = this.searchData;
      this.$apiFetch
        .get("/lockerBorrowRecord/queryLendBorrowRecord1", params)
        .then((res) => {
          this.borrowData = res.data.list;
          this.total = res.data.total;
          this.totalpage = res.data.pages;
        });
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.borrowList();
    },
    //导出
    putOut() {
      const _self = this;
      this.borrowData.map((item) => {
        switch (item.operation) {
          case 1:
            item.operation = "在借";
            break;
          case 2:
            item.operation = "已取出";
            break;
          case 3:
            item.operation = "已归还";
            break;
        }
        if (item.backTime) {
          item.backTime = moment(item.backTime).format("YYYY-MM-DD HH:mm:ss");
        }
      });
      let jsonData = {
        trade: {
          tHeader: [
            "药品名称",
            "药品id",
            "借用人",
            "所属课题组",
            "CAS号",
            "结构式",
            "借用时间",
            "归还时间",
            "柜机名称",
            "柜机位置",
            "状态",
          ],
          filterVal: [
            "reagentName",
            "reagentId",
            "createUsername",
            "taskName",
            "casNo",
            "structionImg",
            "gmtCreate",
            "backTime",
            "cabName",
            "cabAddress",
            "operation",
          ],
          list: _self.borrowData,
        },
      };
      console.log(jsonData);
      _self.exportPathMethod(jsonData); // 调用exportPathMethod对数据进行处理导出
      _self.exportShow = false;
      _self.borrowList();
    },
    exportPathMethod(data) {
      /*
       *注：csv文件：","逗号换列，\n换行，\t防止excel将长数字变科学计算法等样式
       */
      //要导出的json数据
      let mainLists = data.trade; //主表
      //let _self = this;
      //## 数据处理
      //一级表
      let mainTitle = mainLists.tHeader; //一级标题
      let mainTitleForKey = mainLists.filterVal; //一级过滤
      let mainList = mainLists.list; //一级数据
      let mainStr = [];
      mainStr.push(mainTitle.join("\t,") + "\n"); //标题添加上换列转成字符串并存进数组
      for (let i = 0; i < mainList.length; i++) {
        let temp = [];
        for (let j = 0; j < mainTitleForKey.length; j++) {
          if (mainList[i][mainTitleForKey[j]]) {
            temp.push('"' + mainList[i][mainTitleForKey[j]] + '"'); //根据过滤器拿出对应的值
          } else {
            temp.push("");
          }
        }
        mainStr.push(temp.join("\t,") + "\n"); //取出来的值加上逗号换列转字符串存数组
      }
      // console.log(JSON.stringify(mainStr.join("")));//打印文本

      //两个表数组转成字符串合并
      let merged = mainStr.join("");
      console.log(JSON.stringify(merged)); //打印结果

      //## 导出操作
      // encodeURIComponent解决中文乱码
      const uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(merged);
      // 通过创建a标签实现
      let link = document.createElement("a");
      link.href = uri;
      // 对下载的文件命名
      link.download = `借用信息${Date.now()}.csv`;
      document.body.appendChild(link);
      link.click();
    },
    //手动确认取出成功
    async putOutSuccess(info) {
      console.log(info);
      const id = info;
      const that = this;
      this.$confirm("请确认是否取出试剂?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$apiFetch.get("/lockerReagent/borrowReagent", {
            id,
          });
          if (!res.data.code) {
            this.$message.success("取出成功");
            that.borrowList();
          } else {
            this.$message.error(res.data.description);
          }
        })
        .catch(() => {});
    },
    //手动归还
    async putBackSuccess(info) {
      console.log(info);
      const id = info;
      const that = this;
      this.$confirm("请确定试剂已经存放到柜机中", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$apiFetch.get(
            "/lockerReagent/borrowWarehous",
            { id }
          );
          if (!res.data.code) {
            this.$message.success("入库成功");
            that.borrowList();
          } else {
            this.$message.error(res.data.description);
          }
        })
        .catch(() => {});
    },
    //取消转借申请
    async cancelBorrowApply(info) {
      const id = info.recordId;
      const that = this;
      this.$confirm("确认取消转借申请？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$apiFetch.post(
          "/lockerBorrowRecord/CancelReagent",
          { id }
        );
        if (!res.data.code) {
          this.$message.success("取消成功");
          this.$apiFetch
              .get("/lockerBorrowRecord/getBorrowNoticeNum")
              .then((res) => {
                localStorage.setItem("lendNum",res.data);
                EventBus.$emit('lendNum',res.data);
              });
          that.borrowList();
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
    //同意转借
    async agreeBorrowApply(info) {
      const id = info.recordId;
      const that = this;
      this.$confirm("确认将该试剂转给对方使用？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$apiFetch.post("/lockerBorrowRecord/agreeLend", {
          id,
        });
        if (!res.data.code) {
          this.$message.success("同意转用成功");

          this.$apiFetch
              .get("/lockerBorrowRecord/getBorrowNoticeNum")
              .then((res) => {
                localStorage.setItem("lendNum",res.data);
                EventBus.$emit('lendNum',res.data);
              });
          that.borrowList();
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
    //拒绝转借
    async disBorrowApply(info) {
      const id = info.recordId;
      const that = this;
      this.$prompt("拒绝转用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(async ({ value }) => {
          if (!value) {
            this.$message.error("请输入拒绝原因！");
            return;
          }
          const res = await this.$apiFetch.post(
            "/lockerBorrowRecord/refuseLend",
            { id, reason: value }
          );
          if (!res.data.code) {
            this.$message.success("拒绝转用成功");

            this.$apiFetch
                .get("/lockerBorrowRecord/getBorrowNoticeNum")
                .then((res) => {
                  localStorage.setItem("lendNum",res.data);
                  EventBus.$emit('lendNum',res.data);
                });
            that.borrowList();
          } else {
            this.$message.error(res.data.description);
          }
        })
        .catch(() => {});
    },
    //确认收到
    async confirmGet(info) {
      const id = info.recordId;
      const that = this;
      this.$confirm("确认已收到试剂？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$apiFetch.post(
          "/lockerBorrowRecord/confirmLend",
          { id }
        );
        if (!res.data.code) {
          this.$message.success("确认收到成功");

          this.$apiFetch
              .get("/lockerBorrowRecord/getBorrowNoticeNum")
              .then((res) => {
                localStorage.setItem("lendNum",res.data);
                EventBus.$emit('lendNum',res.data);
              });
          that.borrowList();
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
    //未收到
    async disGet(info) {
      const id = info.recordId;
      const that = this;
      this.$confirm("确认未收到试剂？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await this.$apiFetch.post(
          "/lockerBorrowRecord/cancelLend",
          { id }
        );
        if (!res.data.code) {
          this.$message.success("确认未收到");

          this.$apiFetch
              .get("/lockerBorrowRecord/getBorrowNoticeNum")
              .then((res) => {
                localStorage.setItem("lendNum",res.data);
                EventBus.$emit('lendNum',res.data);
              });
          that.borrowList();
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
    handleClick1(tab, event) {
      console.log(tab, event);
    }
  },
};
</script>
<style lang="less" scoped>
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      display: flex;
      align-items: center;
      .search-wrapper {
        margin-right: var(--zng-gap);
        span{
          margin-right: 10px;
        }
        .el-input {
          width: 260px;
        }
      }
    }
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
}
.supTable {
  img {
    width: 100px;
    height: 100px;
  }
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
</style>
